/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  BulkToggleDevourIQBody,
  BulkToggleDevourIQResponse,
  Business,
  BusinessAddUserBody,
  BusinessDeleteUserBody,
  BusinessKeys,
  BusinessServiceAvailabilityBody,
  BusinessType,
  BusinessUpdateUserBody,
  CreateBusinessBody,
  DisableBusinessBody,
  FavoriteMerchantsResponse,
  GetBusinessBillingResponse,
  GetBusinessOwnActiveStatus,
  GetBusinessOwnArchivedStatus,
  GetBusinessOwnEnabledStatus,
  GetBusinessOwnMenuStatus,
  GetBusinessOwnPos,
  GetBusinessOwnSearchCategory,
  GetBusinessOwnSort,
  GetBusinessPermissionsResponse,
  GetBusinessPermissionsSort,
  GetBusinessesChildrenResponse,
  GetBusinessesOwnResponse,
  GetMenuOrdersResponse,
  GetMenuOrdersSort,
  GetMerchantsResponse,
  GetMerchantsSort,
  GetOrderAgainMerchantsResponse,
  HandoffOptions,
  ImportBusinessBody,
  ImportBusinessResponse,
  MenuOrderStatus,
  Merchant,
  SearchMerchantsPromosResponse,
  SearchMerchantsResponse,
  SortOrder,
  UpdateBulkBusinessActiveBody,
  UpdateBulkBusinessEnableBody,
  UpdateBusinessAdmin,
  UpdateBusinessBillingBody,
  UpdateBusinessChowlyBody,
  UpdateBusinessImagesBody,
  UpdateBusinessMarketplaceFeeBody,
  UpdateBusinessParentBody,
  UpdateBusinessSpecialInstructionsBody,
  UpdateBusinessesImagesBody,
  ValidateDeliveryDistanceResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    BulkToggleDevourIQBodyFromJSON,
    BulkToggleDevourIQBodyToJSON,
    BulkToggleDevourIQResponseFromJSON,
    BulkToggleDevourIQResponseToJSON,
    BusinessFromJSON,
    BusinessToJSON,
    BusinessAddUserBodyFromJSON,
    BusinessAddUserBodyToJSON,
    BusinessDeleteUserBodyFromJSON,
    BusinessDeleteUserBodyToJSON,
    BusinessKeysFromJSON,
    BusinessKeysToJSON,
    BusinessServiceAvailabilityBodyFromJSON,
    BusinessServiceAvailabilityBodyToJSON,
    BusinessTypeFromJSON,
    BusinessTypeToJSON,
    BusinessUpdateUserBodyFromJSON,
    BusinessUpdateUserBodyToJSON,
    CreateBusinessBodyFromJSON,
    CreateBusinessBodyToJSON,
    DisableBusinessBodyFromJSON,
    DisableBusinessBodyToJSON,
    FavoriteMerchantsResponseFromJSON,
    FavoriteMerchantsResponseToJSON,
    GetBusinessBillingResponseFromJSON,
    GetBusinessBillingResponseToJSON,
    GetBusinessOwnActiveStatusFromJSON,
    GetBusinessOwnActiveStatusToJSON,
    GetBusinessOwnArchivedStatusFromJSON,
    GetBusinessOwnArchivedStatusToJSON,
    GetBusinessOwnEnabledStatusFromJSON,
    GetBusinessOwnEnabledStatusToJSON,
    GetBusinessOwnMenuStatusFromJSON,
    GetBusinessOwnMenuStatusToJSON,
    GetBusinessOwnPosFromJSON,
    GetBusinessOwnPosToJSON,
    GetBusinessOwnSearchCategoryFromJSON,
    GetBusinessOwnSearchCategoryToJSON,
    GetBusinessOwnSortFromJSON,
    GetBusinessOwnSortToJSON,
    GetBusinessPermissionsResponseFromJSON,
    GetBusinessPermissionsResponseToJSON,
    GetBusinessPermissionsSortFromJSON,
    GetBusinessPermissionsSortToJSON,
    GetBusinessesChildrenResponseFromJSON,
    GetBusinessesChildrenResponseToJSON,
    GetBusinessesOwnResponseFromJSON,
    GetBusinessesOwnResponseToJSON,
    GetMenuOrdersResponseFromJSON,
    GetMenuOrdersResponseToJSON,
    GetMenuOrdersSortFromJSON,
    GetMenuOrdersSortToJSON,
    GetMerchantsResponseFromJSON,
    GetMerchantsResponseToJSON,
    GetMerchantsSortFromJSON,
    GetMerchantsSortToJSON,
    GetOrderAgainMerchantsResponseFromJSON,
    GetOrderAgainMerchantsResponseToJSON,
    HandoffOptionsFromJSON,
    HandoffOptionsToJSON,
    ImportBusinessBodyFromJSON,
    ImportBusinessBodyToJSON,
    ImportBusinessResponseFromJSON,
    ImportBusinessResponseToJSON,
    MenuOrderStatusFromJSON,
    MenuOrderStatusToJSON,
    MerchantFromJSON,
    MerchantToJSON,
    SearchMerchantsPromosResponseFromJSON,
    SearchMerchantsPromosResponseToJSON,
    SearchMerchantsResponseFromJSON,
    SearchMerchantsResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    UpdateBulkBusinessActiveBodyFromJSON,
    UpdateBulkBusinessActiveBodyToJSON,
    UpdateBulkBusinessEnableBodyFromJSON,
    UpdateBulkBusinessEnableBodyToJSON,
    UpdateBusinessAdminFromJSON,
    UpdateBusinessAdminToJSON,
    UpdateBusinessBillingBodyFromJSON,
    UpdateBusinessBillingBodyToJSON,
    UpdateBusinessChowlyBodyFromJSON,
    UpdateBusinessChowlyBodyToJSON,
    UpdateBusinessImagesBodyFromJSON,
    UpdateBusinessImagesBodyToJSON,
    UpdateBusinessMarketplaceFeeBodyFromJSON,
    UpdateBusinessMarketplaceFeeBodyToJSON,
    UpdateBusinessParentBodyFromJSON,
    UpdateBusinessParentBodyToJSON,
    UpdateBusinessSpecialInstructionsBodyFromJSON,
    UpdateBusinessSpecialInstructionsBodyToJSON,
    UpdateBusinessesImagesBodyFromJSON,
    UpdateBusinessesImagesBodyToJSON,
    ValidateDeliveryDistanceResponseFromJSON,
    ValidateDeliveryDistanceResponseToJSON,
} from '../models/index';

export interface CreateBusinessesRequest {
    createBusinessBody?: CreateBusinessBody;
}

export interface CreateBusinessesIdUsersRequest {
    id: string;
    businessAddUserBody?: BusinessAddUserBody;
}

export interface CreateBusinessesImportRequest {
    importBusinessBody?: ImportBusinessBody;
}

export interface DeleteBusinessesIdUsersRequest {
    id: string;
    businessDeleteUserBody?: BusinessDeleteUserBody;
}

export interface GetBusinessesIdRequest {
    id: string;
}

export interface GetBusinessesIdBillingRequest {
    id: string;
}

export interface GetBusinessesIdChildrenRequest {
    id: string;
}

export interface GetBusinessesIdKeysRequest {
    id: string;
}

export interface GetBusinessesIdMenuOrdersRequest {
    id: string;
    status?: Array<MenuOrderStatus>;
    sort?: GetMenuOrdersSort;
    searchValue?: string;
    dateStart?: string;
    dateEnd?: string;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetBusinessesIdPermissionsRequest {
    id: string;
    sort?: GetBusinessPermissionsSort;
    order?: SortOrder;
    search?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetBusinessesOwnSearchRequest {
    type?: Array<BusinessType>;
    ids?: Array<string>;
    search?: string;
    searchCategory?: GetBusinessOwnSearchCategory;
    merchant?: string;
    sort?: GetBusinessOwnSort;
    order?: SortOrder;
    isEnabled?: GetBusinessOwnEnabledStatus;
    isArchived?: GetBusinessOwnArchivedStatus;
    isActive?: GetBusinessOwnActiveStatus;
    pos?: GetBusinessOwnPos;
    menus?: GetBusinessOwnMenuStatus;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetMerchantsRequest {
    ids?: Array<string>;
    sort?: GetMerchantsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetMerchantsFullIdRequest {
    id: string;
    placeId?: string;
}

export interface GetMerchantsOrderAgainRequest {
    placeId?: string;
    handoff?: string;
}

export interface GetMerchantsSearchRequest {
    taxonomyIds?: Array<string>;
    search?: string;
    placeId?: string;
    formattedAddress?: string;
    handoff?: HandoffOptions;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetMerchantsSearchPromosRequest {
    placeId?: string;
    handoff?: string;
}

export interface GetValidateDeliveryDistanceIdRequest {
    id: string;
    merchant?: string;
}

export interface UpdateBulkToggleDevouriqRequest {
    bulkToggleDevourIQBody?: BulkToggleDevourIQBody;
}

export interface UpdateBusinessesIdAdminRequest {
    id: string;
    updateBusinessAdmin?: UpdateBusinessAdmin;
}

export interface UpdateBusinessesIdBillingRequest {
    id: string;
    updateBusinessBillingBody?: UpdateBusinessBillingBody;
}

export interface UpdateBusinessesIdChowlyRequest {
    id: string;
    updateBusinessChowlyBody?: UpdateBusinessChowlyBody;
}

export interface UpdateBusinessesIdContactRequest {
    id: string;
    createBusinessBody?: CreateBusinessBody;
}

export interface UpdateBusinessesIdDisableRequest {
    id: string;
    disableBusinessBody?: DisableBusinessBody;
}

export interface UpdateBusinessesIdImagesRequest {
    id: string;
    updateBusinessImagesBody?: UpdateBusinessImagesBody;
}

export interface UpdateBusinessesIdMarketplaceFeeRequest {
    id: string;
    updateBusinessMarketplaceFeeBody?: UpdateBusinessMarketplaceFeeBody;
}

export interface UpdateBusinessesIdMerchantRequest {
    id: string;
    createBusinessBody?: CreateBusinessBody;
}

export interface UpdateBusinessesIdParentRequest {
    id: string;
    updateBusinessParentBody?: UpdateBusinessParentBody;
}

export interface UpdateBusinessesIdServiceAvailabilityRequest {
    id: string;
    businessServiceAvailabilityBody?: BusinessServiceAvailabilityBody;
}

export interface UpdateBusinessesIdSpecialInstructionsRequest {
    id: string;
    updateBusinessSpecialInstructionsBody?: UpdateBusinessSpecialInstructionsBody;
}

export interface UpdateBusinessesIdToggleArchiveBusinessRequest {
    id: string;
}

export interface UpdateBusinessesIdToggleDisableBusinessRequest {
    id: string;
}

export interface UpdateBusinessesIdUsersRequest {
    id: string;
    businessUpdateUserBody?: BusinessUpdateUserBody;
}

export interface UpdateBusinessesImagesRequest {
    updateBusinessesImagesBody?: UpdateBusinessesImagesBody;
}

export interface UpdateUpdateBulkBusinessActiveRequest {
    updateBulkBusinessActiveBody?: UpdateBulkBusinessActiveBody;
}

export interface UpdateUpdateBulkBusinessEnableRequest {
    updateBulkBusinessEnableBody?: UpdateBulkBusinessEnableBody;
}

/**
 * BusinessesApi - interface
 * 
 * @export
 * @interface BusinessesApiInterface
 */
export interface BusinessesApiInterface {
    /**
     * Used to create new businesses
     * @param {CreateBusinessBody} [createBusinessBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    createBusinessesRaw(requestParameters: CreateBusinessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>>;

    /**
     * Used to create new businesses
     */
    createBusinesses(requestParameters: CreateBusinessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business>;

    /**
     * Used to add a new user to a business.
     * @param {string} id 
     * @param {BusinessAddUserBody} [businessAddUserBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    createBusinessesIdUsersRaw(requestParameters: CreateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to add a new user to a business.
     */
    createBusinessesIdUsers(requestParameters: CreateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to import new businesses
     * @param {ImportBusinessBody} [importBusinessBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    createBusinessesImportRaw(requestParameters: CreateBusinessesImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportBusinessResponse>>;

    /**
     * Used to import new businesses
     */
    createBusinessesImport(requestParameters: CreateBusinessesImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportBusinessResponse>;

    /**
     * Used to remove a user from the business.
     * @param {string} id 
     * @param {BusinessDeleteUserBody} [businessDeleteUserBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    deleteBusinessesIdUsersRaw(requestParameters: DeleteBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to remove a user from the business.
     */
    deleteBusinessesIdUsers(requestParameters: DeleteBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to get the details of a single business
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesIdRaw(requestParameters: GetBusinessesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>>;

    /**
     * Used to get the details of a single business
     */
    getBusinessesId(requestParameters: GetBusinessesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business>;

    /**
     * Used to get the Stripe account details for a business.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesIdBillingRaw(requestParameters: GetBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessBillingResponse>>;

    /**
     * Used to get the Stripe account details for a business.
     */
    getBusinessesIdBilling(requestParameters: GetBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessBillingResponse>;

    /**
     * Used to get the children of a single business
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesIdChildrenRaw(requestParameters: GetBusinessesIdChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessesChildrenResponse>>;

    /**
     * Used to get the children of a single business
     */
    getBusinessesIdChildren(requestParameters: GetBusinessesIdChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessesChildrenResponse>;

    /**
     * Used to get the sensitive api keys of a single business
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesIdKeysRaw(requestParameters: GetBusinessesIdKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessKeys>>;

    /**
     * Used to get the sensitive api keys of a single business
     */
    getBusinessesIdKeys(requestParameters: GetBusinessesIdKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessKeys>;

    /**
     * Used by business owners to get a list of all menu orders
     * @param {string} id 
     * @param {Array<MenuOrderStatus>} [status] 
     * @param {GetMenuOrdersSort} [sort] 
     * @param {string} [searchValue] 
     * @param {string} [dateStart] 
     * @param {string} [dateEnd] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesIdMenuOrdersRaw(requestParameters: GetBusinessesIdMenuOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersResponse>>;

    /**
     * Used by business owners to get a list of all menu orders
     */
    getBusinessesIdMenuOrders(requestParameters: GetBusinessesIdMenuOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersResponse>;

    /**
     * Used to get a list of permissions for this specific business that this user has.
     * @param {string} id 
     * @param {GetBusinessPermissionsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesIdPermissionsRaw(requestParameters: GetBusinessesIdPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessPermissionsResponse>>;

    /**
     * Used to get a list of permissions for this specific business that this user has.
     */
    getBusinessesIdPermissions(requestParameters: GetBusinessesIdPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessPermissionsResponse>;

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     * @param {Array<BusinessType>} [type] 
     * @param {Array<string>} [ids] 
     * @param {string} [search] 
     * @param {GetBusinessOwnSearchCategory} [searchCategory] 
     * @param {string} [merchant] 
     * @param {GetBusinessOwnSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {GetBusinessOwnEnabledStatus} [isEnabled] 
     * @param {GetBusinessOwnArchivedStatus} [isArchived] 
     * @param {GetBusinessOwnActiveStatus} [isActive] 
     * @param {GetBusinessOwnPos} [pos] 
     * @param {GetBusinessOwnMenuStatus} [menus] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getBusinessesOwnSearchRaw(requestParameters: GetBusinessesOwnSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessesOwnResponse>>;

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     */
    getBusinessesOwnSearch(requestParameters: GetBusinessesOwnSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessesOwnResponse>;

    /**
     * Used to get merchants by customers with more flexible options.
     * @param {Array<string>} [ids] 
     * @param {GetMerchantsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getMerchantsRaw(requestParameters: GetMerchantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMerchantsResponse>>;

    /**
     * Used to get merchants by customers with more flexible options.
     */
    getMerchants(requestParameters: GetMerchantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMerchantsResponse>;

    /**
     * Used to get favorite merchants for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getMerchantsFavoritesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteMerchantsResponse>>;

    /**
     * Used to get favorite merchants for user
     */
    getMerchantsFavorites(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteMerchantsResponse>;

    /**
     * Used to get the details of a single merchant. Heavier API than `getBusiness`. Requires place ID for distance check. Compares service availability time with menu time.
     * @param {string} id 
     * @param {string} [placeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getMerchantsFullIdRaw(requestParameters: GetMerchantsFullIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Merchant>>;

    /**
     * Used to get the details of a single merchant. Heavier API than `getBusiness`. Requires place ID for distance check. Compares service availability time with menu time.
     */
    getMerchantsFullId(requestParameters: GetMerchantsFullIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Merchant>;

    /**
     * Used to get the nearby merchants that user has ordered at before.
     * @param {string} [placeId] 
     * @param {string} [handoff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getMerchantsOrderAgainRaw(requestParameters: GetMerchantsOrderAgainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrderAgainMerchantsResponse>>;

    /**
     * Used to get the nearby merchants that user has ordered at before.
     */
    getMerchantsOrderAgain(requestParameters: GetMerchantsOrderAgainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrderAgainMerchantsResponse>;

    /**
     * Used to get merchants by proximity range to customer
     * @param {Array<string>} [taxonomyIds] 
     * @param {string} [search] 
     * @param {string} [placeId] 
     * @param {string} [formattedAddress] 
     * @param {HandoffOptions} [handoff] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getMerchantsSearchRaw(requestParameters: GetMerchantsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMerchantsResponse>>;

    /**
     * Used to get merchants by proximity range to customer
     */
    getMerchantsSearch(requestParameters: GetMerchantsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMerchantsResponse>;

    /**
     * Used to get promos by proximity range to customer
     * @param {string} [placeId] 
     * @param {string} [handoff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getMerchantsSearchPromosRaw(requestParameters: GetMerchantsSearchPromosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMerchantsPromosResponse>>;

    /**
     * Used to get promos by proximity range to customer
     */
    getMerchantsSearchPromos(requestParameters: GetMerchantsSearchPromosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMerchantsPromosResponse>;

    /**
     * Used to validate if specified {placeid} is in valid delivery distance of requested merchant.
     * @param {string} id 
     * @param {string} [merchant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    getValidateDeliveryDistanceIdRaw(requestParameters: GetValidateDeliveryDistanceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateDeliveryDistanceResponse>>;

    /**
     * Used to validate if specified {placeid} is in valid delivery distance of requested merchant.
     */
    getValidateDeliveryDistanceId(requestParameters: GetValidateDeliveryDistanceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateDeliveryDistanceResponse>;

    /**
     * Used to update the stripe account for this business to receive payment
     * @param {BulkToggleDevourIQBody} [bulkToggleDevourIQBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBulkToggleDevouriqRaw(requestParameters: UpdateBulkToggleDevouriqRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkToggleDevourIQResponse>>;

    /**
     * Used to update the stripe account for this business to receive payment
     */
    updateBulkToggleDevouriq(requestParameters: UpdateBulkToggleDevouriqRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkToggleDevourIQResponse>;

    /**
     * Used to update existing businesses. For admins. Merchants can use `updateBusinessContact`.
     * @param {string} id 
     * @param {UpdateBusinessAdmin} [updateBusinessAdmin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdAdminRaw(requestParameters: UpdateBusinessesIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing businesses. For admins. Merchants can use `updateBusinessContact`.
     */
    updateBusinessesIdAdmin(requestParameters: UpdateBusinessesIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update the stripe account for this business to receive payment
     * @param {string} id 
     * @param {UpdateBusinessBillingBody} [updateBusinessBillingBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdBillingRaw(requestParameters: UpdateBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update the stripe account for this business to receive payment
     */
    updateBusinessesIdBilling(requestParameters: UpdateBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update the Chowly API key for this business
     * @param {string} id 
     * @param {UpdateBusinessChowlyBody} [updateBusinessChowlyBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdChowlyRaw(requestParameters: UpdateBusinessesIdChowlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update the Chowly API key for this business
     */
    updateBusinessesIdChowly(requestParameters: UpdateBusinessesIdChowlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update existing businesses. For merchants, admins can use `updateBusinessAdmin`.
     * @param {string} id 
     * @param {CreateBusinessBody} [createBusinessBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdContactRaw(requestParameters: UpdateBusinessesIdContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing businesses. For merchants, admins can use `updateBusinessAdmin`.
     */
    updateBusinessesIdContact(requestParameters: UpdateBusinessesIdContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by merchants to permanently remove this business from the system.
     * @param {string} id 
     * @param {DisableBusinessBody} [disableBusinessBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdDisableRaw(requestParameters: UpdateBusinessesIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by merchants to permanently remove this business from the system.
     */
    updateBusinessesIdDisable(requestParameters: UpdateBusinessesIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update images for existing businesses
     * @param {string} id 
     * @param {UpdateBusinessImagesBody} [updateBusinessImagesBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdImagesRaw(requestParameters: UpdateBusinessesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update images for existing businesses
     */
    updateBusinessesIdImages(requestParameters: UpdateBusinessesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update marketplace fees for a business.
     * @param {string} id 
     * @param {UpdateBusinessMarketplaceFeeBody} [updateBusinessMarketplaceFeeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdMarketplaceFeeRaw(requestParameters: UpdateBusinessesIdMarketplaceFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update marketplace fees for a business.
     */
    updateBusinessesIdMarketplaceFee(requestParameters: UpdateBusinessesIdMarketplaceFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update existing businesses by Merchant.
     * @param {string} id 
     * @param {CreateBusinessBody} [createBusinessBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdMerchantRaw(requestParameters: UpdateBusinessesIdMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing businesses by Merchant.
     */
    updateBusinessesIdMerchant(requestParameters: UpdateBusinessesIdMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update the parent entity for this business
     * @param {string} id 
     * @param {UpdateBusinessParentBody} [updateBusinessParentBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdParentRaw(requestParameters: UpdateBusinessesIdParentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update the parent entity for this business
     */
    updateBusinessesIdParent(requestParameters: UpdateBusinessesIdParentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update hours and service availability for businesses
     * @param {string} id 
     * @param {BusinessServiceAvailabilityBody} [businessServiceAvailabilityBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdServiceAvailabilityRaw(requestParameters: UpdateBusinessesIdServiceAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update hours and service availability for businesses
     */
    updateBusinessesIdServiceAvailability(requestParameters: UpdateBusinessesIdServiceAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update the Special Instructions entity for this business
     * @param {string} id 
     * @param {UpdateBusinessSpecialInstructionsBody} [updateBusinessSpecialInstructionsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdSpecialInstructionsRaw(requestParameters: UpdateBusinessesIdSpecialInstructionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update the Special Instructions entity for this business
     */
    updateBusinessesIdSpecialInstructions(requestParameters: UpdateBusinessesIdSpecialInstructionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admins to archive or unarchive a business (via Merchants page of the Admin Portal).
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdToggleArchiveBusinessRaw(requestParameters: UpdateBusinessesIdToggleArchiveBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to archive or unarchive a business (via Merchants page of the Admin Portal).
     */
    updateBusinessesIdToggleArchiveBusiness(requestParameters: UpdateBusinessesIdToggleArchiveBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admins to disable or enable a business (via Merchants page of the Admin Portal).
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdToggleDisableBusinessRaw(requestParameters: UpdateBusinessesIdToggleDisableBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to disable or enable a business (via Merchants page of the Admin Portal).
     */
    updateBusinessesIdToggleDisableBusiness(requestParameters: UpdateBusinessesIdToggleDisableBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update a user\'s permissions on the business.
     * @param {string} id 
     * @param {BusinessUpdateUserBody} [businessUpdateUserBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesIdUsersRaw(requestParameters: UpdateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update a user\'s permissions on the business.
     */
    updateBusinessesIdUsers(requestParameters: UpdateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to bulk update images for a list of businesses
     * @param {UpdateBusinessesImagesBody} [updateBusinessesImagesBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateBusinessesImagesRaw(requestParameters: UpdateBusinessesImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to bulk update images for a list of businesses
     */
    updateBusinessesImages(requestParameters: UpdateBusinessesImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used for Admins to run bulk updates on businesses\' active status.
     * @param {UpdateBulkBusinessActiveBody} [updateBulkBusinessActiveBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateUpdateBulkBusinessActiveRaw(requestParameters: UpdateUpdateBulkBusinessActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used for Admins to run bulk updates on businesses\' active status.
     */
    updateUpdateBulkBusinessActive(requestParameters: UpdateUpdateBulkBusinessActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used for Admins to run bulk updates on businesses\' enabled status.
     * @param {UpdateBulkBusinessEnableBody} [updateBulkBusinessEnableBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    updateUpdateBulkBusinessEnableRaw(requestParameters: UpdateUpdateBulkBusinessEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used for Admins to run bulk updates on businesses\' enabled status.
     */
    updateUpdateBulkBusinessEnable(requestParameters: UpdateUpdateBulkBusinessEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class BusinessesApi extends runtime.BaseAPI implements BusinessesApiInterface {

    /**
     * Used to create new businesses
     */
    async createBusinessesRaw(requestParameters: CreateBusinessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBusinessBodyToJSON(requestParameters['createBusinessBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessFromJSON(jsonValue));
    }

    /**
     * Used to create new businesses
     */
    async createBusinesses(requestParameters: CreateBusinessesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business> {
        const response = await this.createBusinessesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to add a new user to a business.
     */
    async createBusinessesIdUsersRaw(requestParameters: CreateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createBusinessesIdUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/users`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessAddUserBodyToJSON(requestParameters['businessAddUserBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to add a new user to a business.
     */
    async createBusinessesIdUsers(requestParameters: CreateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createBusinessesIdUsersRaw(requestParameters, initOverrides);
    }

    /**
     * Used to import new businesses
     */
    async createBusinessesImportRaw(requestParameters: CreateBusinessesImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportBusinessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportBusinessBodyToJSON(requestParameters['importBusinessBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportBusinessResponseFromJSON(jsonValue));
    }

    /**
     * Used to import new businesses
     */
    async createBusinessesImport(requestParameters: CreateBusinessesImportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportBusinessResponse> {
        const response = await this.createBusinessesImportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to remove a user from the business.
     */
    async deleteBusinessesIdUsersRaw(requestParameters: DeleteBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteBusinessesIdUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/users`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessDeleteUserBodyToJSON(requestParameters['businessDeleteUserBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to remove a user from the business.
     */
    async deleteBusinessesIdUsers(requestParameters: DeleteBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBusinessesIdUsersRaw(requestParameters, initOverrides);
    }

    /**
     * Used to get the details of a single business
     */
    async getBusinessesIdRaw(requestParameters: GetBusinessesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/businesses/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessFromJSON(jsonValue));
    }

    /**
     * Used to get the details of a single business
     */
    async getBusinessesId(requestParameters: GetBusinessesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business> {
        const response = await this.getBusinessesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get the Stripe account details for a business.
     */
    async getBusinessesIdBillingRaw(requestParameters: GetBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessBillingResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdBilling().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/billing`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessBillingResponseFromJSON(jsonValue));
    }

    /**
     * Used to get the Stripe account details for a business.
     */
    async getBusinessesIdBilling(requestParameters: GetBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessBillingResponse> {
        const response = await this.getBusinessesIdBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get the children of a single business
     */
    async getBusinessesIdChildrenRaw(requestParameters: GetBusinessesIdChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessesChildrenResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdChildren().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/businesses/{id}/children`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessesChildrenResponseFromJSON(jsonValue));
    }

    /**
     * Used to get the children of a single business
     */
    async getBusinessesIdChildren(requestParameters: GetBusinessesIdChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessesChildrenResponse> {
        const response = await this.getBusinessesIdChildrenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get the sensitive api keys of a single business
     */
    async getBusinessesIdKeysRaw(requestParameters: GetBusinessesIdKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessKeys>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdKeys().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/keys`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessKeysFromJSON(jsonValue));
    }

    /**
     * Used to get the sensitive api keys of a single business
     */
    async getBusinessesIdKeys(requestParameters: GetBusinessesIdKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessKeys> {
        const response = await this.getBusinessesIdKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by business owners to get a list of all menu orders
     */
    async getBusinessesIdMenuOrdersRaw(requestParameters: GetBusinessesIdMenuOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdMenuOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['searchValue'] = requestParameters['searchValue'];
        }

        if (requestParameters['dateStart'] != null) {
            queryParameters['dateStart'] = requestParameters['dateStart'];
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['dateEnd'] = requestParameters['dateEnd'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/menu-orders`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuOrdersResponseFromJSON(jsonValue));
    }

    /**
     * Used by business owners to get a list of all menu orders
     */
    async getBusinessesIdMenuOrders(requestParameters: GetBusinessesIdMenuOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersResponse> {
        const response = await this.getBusinessesIdMenuOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of permissions for this specific business that this user has.
     */
    async getBusinessesIdPermissionsRaw(requestParameters: GetBusinessesIdPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessPermissionsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdPermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/permissions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessPermissionsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of permissions for this specific business that this user has.
     */
    async getBusinessesIdPermissions(requestParameters: GetBusinessesIdPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessPermissionsResponse> {
        const response = await this.getBusinessesIdPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     */
    async getBusinessesOwnSearchRaw(requestParameters: GetBusinessesOwnSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessesOwnResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchCategory'] != null) {
            queryParameters['searchCategory'] = requestParameters['searchCategory'];
        }

        if (requestParameters['merchant'] != null) {
            queryParameters['merchant'] = requestParameters['merchant'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['isEnabled'] != null) {
            queryParameters['isEnabled'] = requestParameters['isEnabled'];
        }

        if (requestParameters['isArchived'] != null) {
            queryParameters['isArchived'] = requestParameters['isArchived'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['pos'] != null) {
            queryParameters['pos'] = requestParameters['pos'];
        }

        if (requestParameters['menus'] != null) {
            queryParameters['menus'] = requestParameters['menus'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/own/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessesOwnResponseFromJSON(jsonValue));
    }

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     */
    async getBusinessesOwnSearch(requestParameters: GetBusinessesOwnSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessesOwnResponse> {
        const response = await this.getBusinessesOwnSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get merchants by customers with more flexible options.
     */
    async getMerchantsRaw(requestParameters: GetMerchantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMerchantsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/merchants`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMerchantsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get merchants by customers with more flexible options.
     */
    async getMerchants(requestParameters: GetMerchantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMerchantsResponse> {
        const response = await this.getMerchantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get favorite merchants for user
     */
    async getMerchantsFavoritesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteMerchantsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/merchants/favorites`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteMerchantsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get favorite merchants for user
     */
    async getMerchantsFavorites(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteMerchantsResponse> {
        const response = await this.getMerchantsFavoritesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to get the details of a single merchant. Heavier API than `getBusiness`. Requires place ID for distance check. Compares service availability time with menu time.
     */
    async getMerchantsFullIdRaw(requestParameters: GetMerchantsFullIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Merchant>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMerchantsFullId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['placeId'] != null) {
            queryParameters['placeId'] = requestParameters['placeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/merchants/full/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MerchantFromJSON(jsonValue));
    }

    /**
     * Used to get the details of a single merchant. Heavier API than `getBusiness`. Requires place ID for distance check. Compares service availability time with menu time.
     */
    async getMerchantsFullId(requestParameters: GetMerchantsFullIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Merchant> {
        const response = await this.getMerchantsFullIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get the nearby merchants that user has ordered at before.
     */
    async getMerchantsOrderAgainRaw(requestParameters: GetMerchantsOrderAgainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrderAgainMerchantsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['placeId'] != null) {
            queryParameters['placeId'] = requestParameters['placeId'];
        }

        if (requestParameters['handoff'] != null) {
            queryParameters['handoff'] = requestParameters['handoff'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/merchants/order-again`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrderAgainMerchantsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get the nearby merchants that user has ordered at before.
     */
    async getMerchantsOrderAgain(requestParameters: GetMerchantsOrderAgainRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrderAgainMerchantsResponse> {
        const response = await this.getMerchantsOrderAgainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get merchants by proximity range to customer
     */
    async getMerchantsSearchRaw(requestParameters: GetMerchantsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMerchantsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['taxonomyIds'] != null) {
            queryParameters['taxonomyIds'] = requestParameters['taxonomyIds'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['placeId'] != null) {
            queryParameters['placeId'] = requestParameters['placeId'];
        }

        if (requestParameters['formattedAddress'] != null) {
            queryParameters['formattedAddress'] = requestParameters['formattedAddress'];
        }

        if (requestParameters['handoff'] != null) {
            queryParameters['handoff'] = requestParameters['handoff'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/merchants/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMerchantsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get merchants by proximity range to customer
     */
    async getMerchantsSearch(requestParameters: GetMerchantsSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMerchantsResponse> {
        const response = await this.getMerchantsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get promos by proximity range to customer
     */
    async getMerchantsSearchPromosRaw(requestParameters: GetMerchantsSearchPromosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMerchantsPromosResponse>> {
        const queryParameters: any = {};

        if (requestParameters['placeId'] != null) {
            queryParameters['placeId'] = requestParameters['placeId'];
        }

        if (requestParameters['handoff'] != null) {
            queryParameters['handoff'] = requestParameters['handoff'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/merchants/search-promos`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMerchantsPromosResponseFromJSON(jsonValue));
    }

    /**
     * Used to get promos by proximity range to customer
     */
    async getMerchantsSearchPromos(requestParameters: GetMerchantsSearchPromosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMerchantsPromosResponse> {
        const response = await this.getMerchantsSearchPromosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to validate if specified {placeid} is in valid delivery distance of requested merchant.
     */
    async getValidateDeliveryDistanceIdRaw(requestParameters: GetValidateDeliveryDistanceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateDeliveryDistanceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getValidateDeliveryDistanceId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['merchant'] != null) {
            queryParameters['merchant'] = requestParameters['merchant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/validate_delivery_distance/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateDeliveryDistanceResponseFromJSON(jsonValue));
    }

    /**
     * Used to validate if specified {placeid} is in valid delivery distance of requested merchant.
     */
    async getValidateDeliveryDistanceId(requestParameters: GetValidateDeliveryDistanceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateDeliveryDistanceResponse> {
        const response = await this.getValidateDeliveryDistanceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to update the stripe account for this business to receive payment
     */
    async updateBulkToggleDevouriqRaw(requestParameters: UpdateBulkToggleDevouriqRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkToggleDevourIQResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/bulk-toggle-devouriq`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkToggleDevourIQBodyToJSON(requestParameters['bulkToggleDevourIQBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkToggleDevourIQResponseFromJSON(jsonValue));
    }

    /**
     * Used to update the stripe account for this business to receive payment
     */
    async updateBulkToggleDevouriq(requestParameters: UpdateBulkToggleDevouriqRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkToggleDevourIQResponse> {
        const response = await this.updateBulkToggleDevouriqRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to update existing businesses. For admins. Merchants can use `updateBusinessContact`.
     */
    async updateBusinessesIdAdminRaw(requestParameters: UpdateBusinessesIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/admin`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessAdminToJSON(requestParameters['updateBusinessAdmin']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing businesses. For admins. Merchants can use `updateBusinessContact`.
     */
    async updateBusinessesIdAdmin(requestParameters: UpdateBusinessesIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update the stripe account for this business to receive payment
     */
    async updateBusinessesIdBillingRaw(requestParameters: UpdateBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdBilling().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/billing`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessBillingBodyToJSON(requestParameters['updateBusinessBillingBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update the stripe account for this business to receive payment
     */
    async updateBusinessesIdBilling(requestParameters: UpdateBusinessesIdBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdBillingRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update the Chowly API key for this business
     */
    async updateBusinessesIdChowlyRaw(requestParameters: UpdateBusinessesIdChowlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdChowly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/chowly`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessChowlyBodyToJSON(requestParameters['updateBusinessChowlyBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update the Chowly API key for this business
     */
    async updateBusinessesIdChowly(requestParameters: UpdateBusinessesIdChowlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdChowlyRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update existing businesses. For merchants, admins can use `updateBusinessAdmin`.
     */
    async updateBusinessesIdContactRaw(requestParameters: UpdateBusinessesIdContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/contact`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBusinessBodyToJSON(requestParameters['createBusinessBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing businesses. For merchants, admins can use `updateBusinessAdmin`.
     */
    async updateBusinessesIdContact(requestParameters: UpdateBusinessesIdContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdContactRaw(requestParameters, initOverrides);
    }

    /**
     * Used by merchants to permanently remove this business from the system.
     */
    async updateBusinessesIdDisableRaw(requestParameters: UpdateBusinessesIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdDisable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/disable`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DisableBusinessBodyToJSON(requestParameters['disableBusinessBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by merchants to permanently remove this business from the system.
     */
    async updateBusinessesIdDisable(requestParameters: UpdateBusinessesIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdDisableRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update images for existing businesses
     */
    async updateBusinessesIdImagesRaw(requestParameters: UpdateBusinessesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdImages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/images`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessImagesBodyToJSON(requestParameters['updateBusinessImagesBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update images for existing businesses
     */
    async updateBusinessesIdImages(requestParameters: UpdateBusinessesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdImagesRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update marketplace fees for a business.
     */
    async updateBusinessesIdMarketplaceFeeRaw(requestParameters: UpdateBusinessesIdMarketplaceFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdMarketplaceFee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/marketplace-fee`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessMarketplaceFeeBodyToJSON(requestParameters['updateBusinessMarketplaceFeeBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update marketplace fees for a business.
     */
    async updateBusinessesIdMarketplaceFee(requestParameters: UpdateBusinessesIdMarketplaceFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdMarketplaceFeeRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update existing businesses by Merchant.
     */
    async updateBusinessesIdMerchantRaw(requestParameters: UpdateBusinessesIdMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdMerchant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/merchant`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBusinessBodyToJSON(requestParameters['createBusinessBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing businesses by Merchant.
     */
    async updateBusinessesIdMerchant(requestParameters: UpdateBusinessesIdMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdMerchantRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update the parent entity for this business
     */
    async updateBusinessesIdParentRaw(requestParameters: UpdateBusinessesIdParentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdParent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/parent`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessParentBodyToJSON(requestParameters['updateBusinessParentBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update the parent entity for this business
     */
    async updateBusinessesIdParent(requestParameters: UpdateBusinessesIdParentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdParentRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update hours and service availability for businesses
     */
    async updateBusinessesIdServiceAvailabilityRaw(requestParameters: UpdateBusinessesIdServiceAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdServiceAvailability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/service-availability`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessServiceAvailabilityBodyToJSON(requestParameters['businessServiceAvailabilityBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update hours and service availability for businesses
     */
    async updateBusinessesIdServiceAvailability(requestParameters: UpdateBusinessesIdServiceAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdServiceAvailabilityRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update the Special Instructions entity for this business
     */
    async updateBusinessesIdSpecialInstructionsRaw(requestParameters: UpdateBusinessesIdSpecialInstructionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdSpecialInstructions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/special-instructions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessSpecialInstructionsBodyToJSON(requestParameters['updateBusinessSpecialInstructionsBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update the Special Instructions entity for this business
     */
    async updateBusinessesIdSpecialInstructions(requestParameters: UpdateBusinessesIdSpecialInstructionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdSpecialInstructionsRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admins to archive or unarchive a business (via Merchants page of the Admin Portal).
     */
    async updateBusinessesIdToggleArchiveBusinessRaw(requestParameters: UpdateBusinessesIdToggleArchiveBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdToggleArchiveBusiness().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/toggle-archive-business`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to archive or unarchive a business (via Merchants page of the Admin Portal).
     */
    async updateBusinessesIdToggleArchiveBusiness(requestParameters: UpdateBusinessesIdToggleArchiveBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdToggleArchiveBusinessRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admins to disable or enable a business (via Merchants page of the Admin Portal).
     */
    async updateBusinessesIdToggleDisableBusinessRaw(requestParameters: UpdateBusinessesIdToggleDisableBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdToggleDisableBusiness().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/toggle-disable-business`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to disable or enable a business (via Merchants page of the Admin Portal).
     */
    async updateBusinessesIdToggleDisableBusiness(requestParameters: UpdateBusinessesIdToggleDisableBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdToggleDisableBusinessRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update a user\'s permissions on the business.
     */
    async updateBusinessesIdUsersRaw(requestParameters: UpdateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBusinessesIdUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/{id}/users`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessUpdateUserBodyToJSON(requestParameters['businessUpdateUserBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update a user\'s permissions on the business.
     */
    async updateBusinessesIdUsers(requestParameters: UpdateBusinessesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesIdUsersRaw(requestParameters, initOverrides);
    }

    /**
     * Used to bulk update images for a list of businesses
     */
    async updateBusinessesImagesRaw(requestParameters: UpdateBusinessesImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/businesses/images`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessesImagesBodyToJSON(requestParameters['updateBusinessesImagesBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to bulk update images for a list of businesses
     */
    async updateBusinessesImages(requestParameters: UpdateBusinessesImagesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessesImagesRaw(requestParameters, initOverrides);
    }

    /**
     * Used for Admins to run bulk updates on businesses\' active status.
     */
    async updateUpdateBulkBusinessActiveRaw(requestParameters: UpdateUpdateBulkBusinessActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/update-bulk-business-active`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBulkBusinessActiveBodyToJSON(requestParameters['updateBulkBusinessActiveBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used for Admins to run bulk updates on businesses\' active status.
     */
    async updateUpdateBulkBusinessActive(requestParameters: UpdateUpdateBulkBusinessActiveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUpdateBulkBusinessActiveRaw(requestParameters, initOverrides);
    }

    /**
     * Used for Admins to run bulk updates on businesses\' enabled status.
     */
    async updateUpdateBulkBusinessEnableRaw(requestParameters: UpdateUpdateBulkBusinessEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/update-bulk-business-enable`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBulkBusinessEnableBodyToJSON(requestParameters['updateBulkBusinessEnableBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used for Admins to run bulk updates on businesses\' enabled status.
     */
    async updateUpdateBulkBusinessEnable(requestParameters: UpdateUpdateBulkBusinessEnableRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUpdateBulkBusinessEnableRaw(requestParameters, initOverrides);
    }

}
